



























import Component from 'vue-class-component';
import NpInput from '@/components/NpInput.vue';
import { isObject, isString } from '@/utilities/helpers';

@Component({
	inheritAttrs: false,
	props: {
		containerClass: String,
		tooltip: {
			type: [Boolean, String],
			default: false,
		},
		validation: {
			type: [Object, String],
		},
		value: {},
	},
})
export default class NpTextarea extends NpInput {
	// Props
	public containerClass!: string;
	public validation!: any;
	public value!: any;

	public get currentValue() {
		return this.value;
	}

	public set currentValue(value) {
		this.$emit('input', value);
	}

	public get required(): boolean {
		return this.$attrs.required
			|| (isObject(this.validation) && (this.validation as any).required)
			|| (isString(this.validation) && this.validation.indexOf('required') >= 0);
	}
}
